import { Route, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { useContext } from "react";
import { UserContext } from "./Hooks/UserContext";

const LoggedRoute = ({ component: Component, ...rest }) => {
  const { user } = useContext(UserContext);
  return (
    <>
      <Route
        {...rest}
        render={(props) =>
          user !== null ? (
            <>
              <Redirect to="/" />
            </>
          ) : (
            <Component {...props} />
          )
        }
      />
    </>
  );
};

export default LoggedRoute;
